<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <span id="spReadNotification" (click)="readNotification()" style="display:none">ReadNotification</span>
        <div id="notificationList" class="row" style="overflow: hidden; overflow-y: auto">
         
        </div>
      </div>
    </div>
  </div>
</div>
